import {
  ReduxActionErrorTypes,
  ReduxActionTypes,
} from "ee/constants/ReduxActionConstants";
import type { GroupProps } from "ee/pages/AdminSettings/AccessControl/types";

export const groupsReducers = {
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.FETCH_ACL_GROUPS]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.FETCH_ACL_GROUPS_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.FETCH_ACL_GROUPS_SUCCESS]: (state: any, action: any) => ({
    ...state,
    groups: action.payload,
    isLoading: false,
    ...(state.selectedGroup
      ? {
          selectedGroup: {
            ...state.selectedGroup,
            isNew: false,
          },
        }
      : {}),
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.FETCH_ACL_GROUP_BY_ID]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.FETCH_ACL_GROUP_BY_ID_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  [ReduxActionTypes.FETCH_ACL_GROUP_BY_ID_SUCCESS]: (
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any,
  ) => ({
    ...state,
    selectedGroup: {
      ...action.payload,
      isNew: false,
    },
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CREATE_ACL_GROUP]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.CREATE_ACL_GROUP_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CREATE_ACL_GROUP_SUCCESS]: (state: any, action: any) => ({
    ...state,
    selectedGroup: {
      ...action.payload,
      isNew: true,
    },
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CLONE_ACL_GROUP]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.CLONE_ACL_GROUP_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CLONE_ACL_GROUP_SUCCESS]: (state: any, action: any) => ({
    ...state,
    groups: action.payload,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.UPDATE_ACL_GROUP_NAME]: (state: any) => ({
    ...state,
    isSavingName: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.UPDATE_ACL_GROUP_NAME_ERROR]: (state: any) => ({
    ...state,
    isSavingName: false,
  }),
  [ReduxActionTypes.UPDATE_ACL_GROUP_NAME_SUCCESS]: (
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any,
  ) => ({
    ...state,
    selectedGroup: {
      ...state.selectedGroup,
      name: action.payload.name,
      description: action.payload.description,
      isNew: false,
    },
    isSavingName: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.UPDATE_ACL_GROUP_ROLES]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.UPDATE_ACL_GROUP_ROLES_SUCCESS]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.UPDATE_ACL_GROUP_ROLES_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.DELETE_ACL_GROUP]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.DELETE_ACL_GROUP_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.DELETE_ACL_GROUP_SUCCESS]: (state: any, action: any) => ({
    ...state,
    groups: state.groups.filter(
      (group: GroupProps) => group.id !== action.payload.id,
    ),
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.ADD_USERS_IN_GROUP]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.ADD_USERS_IN_GROUP_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.ADD_USERS_IN_GROUP_SUCCESS]: (state: any, action: any) => ({
    ...state,
    selectedGroup: {
      ...state.selectedGroup,
      users: Array.isArray(action.payload)
        ? action.payload[0].users
        : action.payload.users,
      isNew: false,
    },
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.REMOVE_USERS_FROM_GROUP]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.REMOVE_USERS_FROM_GROUP_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  [ReduxActionTypes.REMOVE_USERS_FROM_GROUP_SUCCESS]: (
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any,
  ) => ({
    ...state,
    selectedGroup: {
      ...state.selectedGroup,
      users: Array.isArray(action.payload)
        ? action.payload[0].users
        : action.payload.users,
      isNew: false,
    },
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.RESET_GROUPS_DATA]: (state: any) => ({
    ...state,
    selectedGroup: null,
    groups: [],
  }),
};
